const ISORegex = /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(\d+H)?(\d+M)?(\d+(\.\d+)?S)?)?$/;

const isValidISOString = (isoDuration: any): boolean => {
    return ISORegex.test(isoDuration);
};

export default isValidISOString;
